import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { getArticles, pinArticle } from 'action/article'
import PropTypes from 'prop-types'
import confirmModal from 'view/component/confirm-modal'
import { startCase } from 'lodash'
import { Button } from 'antd'
import styles from './styles'

const generateModalText = (title, pinnedText) => ({
  decide: {
    content: '',
    title: `Are you sure you want to ${pinnedText} ${title}?`
  },

  outcome: {
    content: {
      error: 'Please try Again',
      success: `${title} has been successfully ${pinnedText}ned`
    },
    title: {
      error: `There has been an issue ${pinnedText}ning ${title}`,
      success: `Article ${pinnedText}ned`
    }
  }
})

const PinArticle = ({ pinArticle, getArticles, article: { uuid, title, pinned: isPinned, is_draft: isDraft }, pagination }) => {
  const pinnedText = isPinned ? 'unpin' : 'pin'

  const handleSubmit = () => pinArticle(uuid)

  const { decide, outcome } = generateModalText(title, pinnedText)

  return (
    <Button
      className={styles.menu_item}
      disabled={isDraft}
      onClick={() => confirmModal(handleSubmit, decide, outcome)}
      type='text'
    >{`${startCase(pinnedText)} Article`}</Button>
  )
}

PinArticle.propTypes = {
  article: PropTypes.object,
  getArticles: PropTypes.func,
  pagination: PropTypes.object,
  pinArticle: PropTypes.func
}

const mapDispatchToProps = (dispatch) => ({
  getArticles: bindActionCreators(getArticles, dispatch),
  pinArticle: bindActionCreators(pinArticle, dispatch)
})

const mapStateToProps = (state) => ({
  pagination: state.article.pagination
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PinArticle)
